import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useLogin } from '@/hooks/use-login';

export function RedirectToLogin() {
  const { login } = useLogin();

  useEffect(() => {
    login();
  }, [login]);

  return (
    <div className='flex min-h-screen flex-col items-center justify-center bg-background'>
      <Loader2
        aria-hidden
        className='size-8 animate-spin text-muted-foreground'
      />
    </div>
  );
}
